import { render, staticRenderFns } from "./caseta_parque.vue?vue&type=template&id=4c5aacf7&scoped=true"
import script from "./caseta_parque.vue?vue&type=script&lang=js"
export * from "./caseta_parque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5aacf7",
  null
  
)

export default component.exports